import React, {useState} from "react";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import {
  Paper,
  FormHelperText,
  Button
} from "@material-ui/core";
import {AddBoxOutlined, IndeterminateCheckBoxOutlined} from "@material-ui/icons";

const LabelledPaper = (props) => {

  let theme = useTheme();
  const classes = makeStyles({
      label: {
        marginTop: -13, 
        marginLeft: 5, 
        width: "fit-content"
      },
  })(theme);

  const [open, setOpen] = useState(props.isOpened);

  const handleClick = () => {
    setOpen(!open);
    if (props.onClick) {
      props.onClick();
    }
  }

  const checkChildrenProp = {};
  if (props.checkChildren) {
    checkChildrenProp['checkChildren'] = true;
  }
  return (
    <Paper variant="outlined" style={{...props.style}} {...checkChildrenProp}>
      <div className={classes.label}>
        <Paper elevation={0}>
          {props.collapsible
            ?
              <Button onClick={handleClick}
                      startIcon={props.isOpened === undefined ? <></> : props.isOpened ? <IndeterminateCheckBoxOutlined/> : <AddBoxOutlined/>}
                      style={{...props.labelStyle}}
              >
                {props.label}
              </Button>
            :
              <FormHelperText component="legend" variant={"filled"}> {props.label} </FormHelperText>
          }
        </Paper>
      </div>   
      <div style={{paddingTop: 5, ...props.bodyStyle}}>
        {props.children} 
      </div>
    </Paper>
  );
}

export default LabelledPaper;